/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import { useAssetsBatch } from './useAssetsBatch'
import ValidationInProcess from './components/ValidationInProcess'
import Validations from './components/Validations'
import Processing from './components/Processing'
import { useParams } from 'react-router-dom'
import FailedBatch from './components/FailedBatch'
import {
  ASSET_REGISTRATION_BATCH,
  ASSET_REGISTRATION_BATCH_DESCRIPTION
} from '@/configs/strings/register-multiple-assets'
import Styles from './styles.module.sass'
import ItemNotFound from '@/components/messages/ItemNotFound'

const AssetsBatch = () => {
  const [totalQueueData, setTotalQueueData] = useState()
  const {
    assetBatch,
    isLoading,
    reloadItems: reloadBatch
  } = useAssetsBatch()
  const { batchId } = useParams()
  const processingStates = ['PROCESSING', 'COMPLETED', 'COMPLETED_WITH_FAILS']
  const batchHasErrors = assetBatch?.state === 'COMPLETED_WITH_FAILS'
  const batchIsProcessing = assetBatch?.state === 'PROCESSING'

  return (
    <RegularTemplate
      loadingContent={isLoading}
      title={ASSET_REGISTRATION_BATCH}
      description={ASSET_REGISTRATION_BATCH_DESCRIPTION}
    >
    { !assetBatch &&
      <ItemNotFound />

    }
    { !isLoading && assetBatch &&
      <>
        { assetBatch.state === 'FAILED' &&
          <FailedBatch
            assetBatch={assetBatch}
          />
        }
        { assetBatch.state === 'DRAFT' &&
          <ValidationInProcess batch={assetBatch} />
        }
        { assetBatch.state === 'PENDING' &&
          <Validations
            assetBatch={assetBatch}
            batchFormClass={Styles.defaultWidth}
            reloadBatch={reloadBatch}
            setTotalQueueData={setTotalQueueData}
            totalQueueData={totalQueueData}
            validationTableClass={Styles.defaultWidth}
          />
        }
        { processingStates.includes(assetBatch.state) &&
          <Processing
            batchHasErrors={batchHasErrors}
            batchId={batchId}
            batchIsProcessing={batchIsProcessing}
            batchName={assetBatch.name}
          />
        }
      </>

    }
    </RegularTemplate>
  )
}

export default AssetsBatch
